module.exports = __webpack_public_path__ + "img/QLT-Logo.6746d775.svg";